const ticketmasterCityData = {
  austin: {
    label: 'Austin',
    value: 'austin',
    id: 222
  },
  boston: {
    label: 'Boston',
    value: 'boston',
    id: 235
  },
  charlotte: {
    label: 'Charlotte',
    value: 'charlotte',
    id: 245
  },
  chicago: {
    label: 'Chicago',
    value: 'chicago',
    id: 249
  },
  columbus: {
    label: 'Columbus',
    value: 'columbus',
    id: 259
  },
  dallas: {
    label: 'Dallas-Fort Worth',
    value: 'dallas',
    id: 261
  },
  denver: {
    label: 'Denver',
    value: 'denver',
    id: 264
  },
  detroit: {
    label: 'Detroit',
    value: 'detroit',
    id: 266
  },
  houston: {
    label: 'Houston',
    value: 'houston',
    id: 300
  },
  indianapolis: {
    label: 'Indianapolis',
    value: 'indianapolis',
    id: 303
  },
  jacksonville: {
    label: 'Jacksonville',
    value: 'jacksonville',
    id: 306
  },
  'las-vegas': {
    label: 'Las Vegas',
    value: 'las-vegas',
    id: 319
  },
  london: {
    label: 'London',
    value: 'london',
    id: 602
  },
  'los-angeles': {
    label: 'Los Angeles',
    value: 'los-angeles',
    id: 324
  },
  nashville: {
    label: 'Nashville',
    value: 'nashville',
    id: 343
  },
  'new-york': {
    label: 'New York',
    value: 'new-york',
    id: 345
  },
  philadelphia: {
    label: 'Philadelphia',
    value: 'philadelphia',
    id: 358
  },
  phoenix: {
    label: 'Phoenix',
    value: 'phoenix',
    id: 359
  },
  portland: {
    label: 'Portland',
    value: 'portland',
    id: 362
  },
  'san-diego': {
    label: 'San Diego',
    value: 'san-diego',
    id: 381
  },
  'san-francisco': {
    label: 'San Francisco',
    value: 'san-francisco',
    id: 382
  },
  seattle: {
    label: 'Seattle',
    value: 'seattle',
    id: 385
  },
  'washington-dc': {
    label: 'Washington, DC and Maryland',
    value: 'washington-dc',
    id: 409
  }
};

export default ticketmasterCityData;
